<template>
  <div>
    <v-app-bar app clipped-left elevation="1">
      <v-app-bar-nav-icon
        @click.stop="openDrawerClicked()"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>
        <v-img width="120" src="kmitl_logo.png"></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <LoginButton />
      <LanguageButton />
    </v-app-bar>
  </div>
</template>

<script>
import LanguageButton from "./LanguageButton";
import LoginButton from "./LoginButton";

export default {
  components: {
    LanguageButton,
    LoginButton,
  },
  computed: {},
  methods: {
    openDrawerClicked: function() {
      this.$emit("openDrawerClicked");
    },
  },
};
</script>
